/// <reference types="@types/googlemaps" />

import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation, OnDestroy, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestService } from 'src/app/services/request.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { first, finalize } from 'rxjs/operators';
import { ChartOptions } from 'chart.js';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { CarbonData } from 'src/app/services/request.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SoildataActionComponent } from './soildata-action/soildata-action.component';

declare var google: any;

@Component({
  selector: 'app-organic-conventional',
  templateUrl: './organic-conventional.component.html',
  styleUrls: ['./organic-conventional.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class OrganicConventionalComponent implements OnInit, OnDestroy, AfterViewInit {

  datasets: any[] = [];
  locationForm!: FormGroup;

  map: google.maps.Map | null = null;
  ocs: any;
  ocsTarget: any;
;
  latitude: any = '';
  longitude: any = '';
  loading: boolean = false;
  soilDataAvailable: boolean = false;
  noSoilData: boolean = false;
  predictionDataAvailable: boolean = false;
  benchmarkingDataAvailable: boolean = false;
  economicValuesAvailable: boolean = false;

  clay: any = 0;
  clayTarget: any = '';
  sand: any = 0;
  sandTarget: any = '';
  silt: any = 0;
  siltTarget: any = '';
  soc: any = 0;
  socTarget: any = '';
  ocd: any = 0;
  ocdTarget: any = '';
  bdod: any = 0;
  bdodTarget: any = '';
  ph: any = '';
  nitro: any = 0;
  phosphorus: any = null;
  potassium: any = null;
  nitroTarget: any = '';
  soilTexture: any = '';
  temperature: any = 0;
  precipitation: any = 0;
  farmingSystem: any = '';
  farmingSystems: any = ["Conventional"];
  cropType: any = '';
  cropTypes: any = ["Barley", "Carrot", "Chickpea", "Citrus", "Maize", "Oat", "Peas", "Rice", "Sunflower", "Soybean", "Tomato", "Wheat", "Potato"]
  farmArea: number = 0;
  yield: any = 0;
  nutsId: string = '';

  climate: number = 0;
  climateResilience: number = 0;
  excessNutrients: number = 0;
  soilFertility: number = 0;
  diseaseControl: number = 0;

  radarChartOptions: ChartOptions<'radar'> = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
  };
  radarChartLabels = ['Climate', 'Climate Resilience', 'Disease Control', 'Excess Nutrients', 'Soil Fertility'];
  radarData = [{ label: 'NCP Scores', data: [0, 0, 0, 0, 0] }];
  barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        ticks: {
          color: '#000',
        },
      },
    },
  };

  barChartLabels: string[] = ['Yield', 'Carbon', 'SWC'];
  barChartData: any[] = [{ data: [0, 0] }];
  firstTableData: any[] = [];
  secondTableData: any[] = [];
  ncpColumns: string[] = ['ncp', 'conventional', 'organic', 'economic'];
  measureColumns: string[] = ['measureName', 'measure', 'unit']
  landType: any = '';
  pointColor = 'rgb(113,187,212)';
  lowerLineColor = 'rgb(255, 99, 132)';
  upperLineColor = 'rgb(255, 205, 86)';
  chartOptions: ChartOptions<'line'> = {
    responsive: false,
    maintainAspectRatio: true,
    scales: {
      x: {
        type: 'linear',
        title: {
          display: true,
          text: 'Observation Value',
          font: { size: 16 },
        },
        ticks: {
          autoSkip: true,
        },
      },
      y: {
        title: {
          display: true,
          text: 'Percentage of soils',
          font: { size: 16 },
        },
        ticks: {
          callback: (value) => `${value}%`,
        },
        min: 0,
        max: 100,
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: true,
        labels: {
          font: { size: 14 },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  chartLegendTrue = true;
  chartLegendFalse = false;
  bulkData: any[] = [];
  phData: any[] = [];
  socData: any[] = [];
  legend = {
    labels: {
      usePointStyle: true,
    },
  };

  markers: google.maps.Marker[] = [];
  showButtons: boolean = false;
  showDelete: boolean = false;
  isSaved: boolean = false;
  savedDataList: any = [];
  selectedSoilData: any = null;
  soilData: any
  selectedChart: string = 'Bulk Density';
  bulkDensityChartData = [];
  soilCarbonChartData = [];
  phChartData = [];
  selectedLocation: number | null = null;

  constructor(private http: HttpClient, private req: RequestService<any>, private fb: FormBuilder, private cdr: ChangeDetectorRef, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
    this.initMap();
    this.initForm();
    this.getSoilData();
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map = null;
    }
  }

  ngAfterViewInit(): void {
    if (this.map) {
      google.maps.event.trigger(this.map, 'resize');
    }
  }

  getSoilData() {
    this.req.getMySoilData().subscribe((res) => {
      this.savedDataList = res
    })
  }

  initForm() {
    this.locationForm = this.fb.group({
      location: [''],
      latitude: [''],
      longitude: ['']
    });

  }

  initMap(): void {
    const mapContainer = document.getElementById('map');
    if (this.map && mapContainer) {
      mapContainer.innerHTML = '';
    }

    const europeBounds = {
      north: 71.0,
      south: 33.0,
      west: -24.0,
      east: 50.0,
    };

    this.map = new google.maps.Map(mapContainer!, {
      zoom: 2,
      center: { lat: 45.0, lng: 14.0 },
      mapTypeId: google.maps.MapTypeId.hybrid,
      mapTypeControl: false,
      streetViewControl: false,
    });

    this.map!.setOptions({
      restriction: {
        latLngBounds: europeBounds,
        strictBounds: true,
      },
    });

    this.req.getGeoData().subscribe((res: any) => {
      res.forEach((feature: any) => {
        const coordinates = feature.geometry.coordinates;
        const isMultiPolygon = feature.geometry.type === "MultiPolygon";
        const paths = isMultiPolygon
          ? coordinates.flatMap((polygon: any) =>
            polygon.map((ring: any) =>
              ring.map((coord: [number, number]) => ({
                lat: coord[1],
                lng: coord[0],
              }))
            )
          )
          : coordinates.map((ring: any) =>
            ring.map((coord: [number, number]) => ({
              lat: coord[1],
              lng: coord[0],
            }))
          );

        paths.forEach((polygonPath: any) => {
          const euPolygon = new google.maps.Polygon({
            paths: polygonPath,
            strokeColor: "#FF0000",
            strokeOpacity: 0,
            strokeWeight: 0,
            fillColor: "#FF0000",
            fillOpacity: 0,
            map: this.map,
          });

          euPolygon.setMap(this.map);
          euPolygon.addListener('click', (event: google.maps.MapMouseEvent) => {
            this.nutsId = feature.properties.NUTS_ID
            this.onMapClick(event);
          });
        })
      })
    })
  }

  onMapClick(event: any) {
    this.selectedSoilData = null;
    this.isSaved = false;
    this.showDelete = false;
    this.farmingSystem = this.farmingSystems[0];
    this.latitude = event.latLng.lat();
    this.longitude = event.latLng.lng();

    console.log(this.latitude)
    console.log(this.longitude)
    this.markers.forEach(marker => marker.setMap(null));
    this.markers = [];

    if (this.map) {
      const newMarker = new google.maps.Marker({
        position: { lat: this.latitude, lng: this.longitude },
        map: this.map,
      });

      this.markers.push(newMarker);

      const geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(this.latitude, this.longitude);

      geocoder.geocode({ location: latLng }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
          const locationName = results[0].formatted_address.substring(results[0].formatted_address.indexOf(' ') + 1);

          this.locationForm.patchValue({
            latitude: this.latitude,
            longitude: this.longitude,
            location: locationName,
          });
        }
      });
    }
    this.cdr.detectChanges();
    this.openSoilDataForm();
  }

  capital(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  async openSoilDataForm() {
    try {
      this.loading = true;
      this.cdr.detectChanges();
      this.resetData();

      this.soilData = await this.req.getExternalSoildata(this.latitude, this.longitude).pipe(first()).toPromise();
      if (this.soilData) {
       this.ocs = this.soilData.soil_data[6]?.unit_measure?.d_factor !== undefined ? 
  this.soilData.soil_data[6].unit_measure.d_factor : "NA";
this.ocsTarget = this.soilData.soil_data[6]?.unit_measure?.target_units || "NA";
        this.clay = this.soilData.soil_data[3]?.depths[2]?.target_value !== undefined ? Math.round(this.soilData.soil_data[3].depths[2].target_value * 10) / 10 : "NA";
        this.clayTarget = this.soilData.soil_data[3]?.unit_measure?.target_units || "NA";
        this.sand = this.soilData.soil_data[8]?.depths[2]?.target_value !== undefined ? Math.round(this.soilData.soil_data[8].depths[2].target_value * 10) / 10 : "NA";
        this.sandTarget = this.soilData.soil_data[8]?.unit_measure?.target_units || "NA";
        this.silt = this.soilData.soil_data[9]?.depths[2]?.target_value !== undefined ? Math.round(this.soilData.soil_data[9].depths[2].target_value * 10) / 10 : "NA";
        this.siltTarget = this.soilData.soil_data[9]?.unit_measure?.target_units || "NA";
        this.soc = this.soilData.soil_data[10]?.depths[2]?.target_value !== undefined ? Math.round(this.soilData.soil_data[10].depths[2].target_value) / 10 : "NA";
        this.socTarget = this.soilData.soil_data[10]?.unit_measure?.target_units || "NA";
        this.ocd = this.soilData.soil_data[5]?.depths[2]?.target_value !== undefined ? Math.round(this.soilData.soil_data[5].depths[2].target_value * 10) / 10 : "NA";
        this.ocdTarget = this.soilData.soil_data[5]?.unit_measure?.target_units || "NA";
        this.bdod = this.soilData.soil_data[0]?.depths[2]?.target_value !== undefined ? Math.round(this.soilData.soil_data[0].depths[2].target_value * 10) / 10 : "NA";
        this.bdodTarget = this.soilData.soil_data[0]?.unit_measure?.target_units || "NA";
        this.ph = this.soilData.soil_data[7]?.depths[2]?.target_value !== undefined ? (this.soilData.soil_data[7].depths[2].target_value).toFixed(2) : "NA";
        this.nitro = this.soilData.soil_data[4]?.depths[2]?.target_value !== undefined ? Math.round(this.soilData.soil_data[4].depths[2].target_value * 10) / 10 : "NA";
        this.nitroTarget = this.soilData.soil_data[4]?.unit_measure?.target_units || "NA";
        this.soilTexture = this.soilData.soil_texture_class?.class ? this.capital(this.soilData.soil_texture_class.class) : "NA";

        const apiUrl = `https://api.weatherapi.com/v1/forecast.json?key=29bf4269b5754b0b903140948222706&q=${this.latitude},${this.longitude}&days=3`;
        this.http.get(apiUrl).subscribe((res: any) => {
          this.temperature = res.forecast.forecastday.reduce((acc: number, day: any) => acc + day.day.avgtemp_c, 0) / 3;
          this.precipitation = res.forecast.forecastday.reduce((acc: number, day: any) => acc + day.day.totalprecip_mm, 0).toFixed(1);
          this.temperature = this.temperature.toFixed(1);
          this.soilDataAvailable = true;
          this.loading = false;
          this.cdr.detectChanges();
        });
      }
      else {
        this.noSoilData = true;
        this.loading = false;
      }
    } catch (error) {
      console.error('Error in openInspectDialog:', error);
      Swal.fire(
        'The SoilGrids API is currently unavailable',
        'This may affect real-time data retrieval for soil inspection. However, you can still access previously saved locations and work with stored data. We apologize for the inconvenience and appreciate your patience while the issue is being resolved.',
        'error'
      );
    }
    this.cdr.detectChanges();
  }

  onCheckboxChange(event: MatCheckboxChange) {
    if (event.checked && !this.isSaved) {
      this.saveData();
      this.showDelete = true;
    };
    this.cdr.detectChanges();
  }

  fillSoilDataForm(savedData: any) {
    this.selectedSoilData = savedData;
    try {
      this.clay = savedData.clay;
      this.ocs=savedData.ocs;
      this.sand = savedData.sand;
      this.silt = savedData.silt;
      this.soc = savedData.soc;
      this.socTarget = savedData.soc_unit;
      this.ocd = savedData.ocd;
      this.ocdTarget = savedData.ocd_unit;
      this.bdod = savedData.bdod;
      this.bdodTarget = savedData.bdod_unit;
      this.ph = savedData.phh2o;
      this.nitro = savedData.nitrogen;
      this.nitroTarget = savedData.nitrogen_unit;
      this.phosphorus = savedData.phosphorus;
      this.potassium = savedData.potassium;
      this.farmingSystem = savedData.farming_system;
      this.cropType = savedData.crop_type;
      this.soilTexture = savedData.soil_texture_class;
      this.temperature = savedData.mean_temp;
      this.precipitation = savedData.total_prec;
      this.farmArea = savedData.area;
      this.yield = savedData.crop_yield;
      this.soilDataAvailable = true;
      this.nutsId = savedData.nuts_id;
      this.locationForm.patchValue({
        latitude: savedData.lat,
        longitude: savedData.lon,
        location: savedData.location,
      });

      this.latitude = Number(savedData.lat);
      this.longitude = Number(savedData.lon);

      this.addMapMarker(this.latitude, this.longitude);
      this.isSaved = this.savedDataList.some((data: any) => data === savedData);
      this.showDelete = this.isSaved && this.isCheckboxChecked();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error populating form from saved data:', error);
    }
  }

  isCheckboxChecked(): boolean {
    return this.selectedSoilData !== null &&
      this.savedDataList.some((data: { id: any; }) => data.id === this.selectedSoilData.id);
  }


  addMapMarker(latitude: number, longitude: number) {
    if (this.map) {
      this.markers.forEach(marker => marker.setMap(null));
      this.markers = [];

      const newMarker = new google.maps.Marker({
        position: { lat: latitude, lng: longitude },
        map: this.map,
      });

      this.markers.push(newMarker);

    }
  }

  saveData() {
    const saveData = {
      lat: String(this.locationForm.value.latitude),
      lon: String(this.locationForm.value.longitude),
      location: this.locationForm.value.location,
      mean_temp: String(this.temperature),
      mean_temp_unit: '°C',
      total_prec: String(this.precipitation),
      total_prec_unit: 'mm',
      nitrogen: String(this.nitro),
      nitrogen_unit: String(this.nitroTarget),
      phosphorus: String(this.phosphorus),
      phosphorus_unit: 'g/kg',
      potassium: String(this.potassium),
      potassium_unit: 'g/kg',
      farming_system: this.farmingSystem,
      crop_type: this.cropType,
      area: String(this.farmArea),
      area_unit: 'ha',
      soil_texture_class: this.soilTexture,
      clay: String(this.clay),
      clay_unit: String(this.clayTarget),
      sand: String(this.sand),
      sand_unit: String(this.sandTarget),
      silt: String(this.silt),
      silt_unit: String(this.siltTarget),
      soc: String(this.soc),
      soc_unit: String(this.socTarget),
      ocd: String(this.ocd),
      ocd_unit: String(this.ocdTarget),
      bdod: String(this.bdod),
      bdod_unit: String(this.bdodTarget),
      phh2o: String(this.ph),
      ocs: String(this.ocs),
      ocs_unit: String(this.ocsTarget),
      crop_yield: String(this.yield),
      nuts_id: String(this.nutsId)
    };

    let dataObj = JSON.stringify(saveData);
    this.req.postSoilData(dataObj).subscribe(() => {
      Swal.fire(
        '',
        'Soil Data saved successfully!',
        'success'
      )
      this.savedDataList.push(saveData)
      this.isSaved = true;
      this.cdr.detectChanges()
    })
  }

  isValidForm() {
    return (this.cropType !== '');
  }

  deleteData(id: any) {
    if (!id) return;

    Swal.fire({
      title: "Are you sure you want to delete this Soil Data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#5da36e",
      cancelButtonColor: "#d33",
      confirmButtonText: "Continue",
    }).then((result) => {
      if (result.isConfirmed) {
        this.req.deleteSoilData(id).subscribe({
          next: () => {
            Swal.fire({
              title: "Deleted!",
              text: "Selected Soil Data has been deleted.",
              icon: "success"
            });
            this.getSoilData();
            this.cdr.detectChanges();
          }
        })
      }
    });
  }

  openActionDialog() {
    const dialogRef = this.dialog.open(SoildataActionComponent, {
      width: '800px',
      data: {
        handleDialogAction: this.handleDialogAction.bind(this),
        latitude: this.latitude,
        longitude: this.longitude,
        crop: this.cropType
      },
      autoFocus: false,
    });
  }


  handleDialogAction(action: string): void {
    switch (action) {
      case 'predictions':
        this.openPredictionsDialog();
        break;
      case 'economical':
        this.getEconomicalData();
        break;
      case 'bareland':
      case 'woodland':
      case 'grassland':
      case 'shrubland':
      case 'cropland':
        this.onLandTypeSelect(action);
        break;
    }
  }

  openPredictionsDialog() {
    Swal.fire({
      title: "This action requires up to 60 seconds to complete.",
      text: "Are you sure you want to continue?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#5da36e",
      cancelButtonColor: "#d33",
      confirmButtonText: "Continue",
    }).then((result) => {
      if (result.isConfirmed) {
        this.getPredictionData();
      }
    });
  }

  async getPredictionData() {
    try {
      this.loading = true;
      this.cdr.detectChanges();
      const modelsData = await this.req.getPredictionModels(this.latitude, this.longitude, this.ph, this.soc)
        .pipe(
          first(),
          finalize(() => {
            this.loading = false;
            this.cdr.detectChanges();
          })
        )
        .toPromise();

      if (modelsData) {
        this.climate = modelsData.ncp_scores.Climate;
        this.climateResilience = modelsData.ncp_scores.Climate_resilience;
        this.diseaseControl = modelsData.ncp_scores.Disease_control;
        this.excessNutrients = modelsData.ncp_scores.Excess_nutrients;
        this.soilFertility = modelsData.ncp_scores.Soil_fertility;

        this.radarData = [{
          label: 'NCP Scores',
          data: [this.climate, this.climateResilience, this.diseaseControl, this.excessNutrients, this.soilFertility]
        }];

        this.predictionDataAvailable = true;
        this.cdr.detectChanges();
      }
    } catch (error) {
      this.cdr.detectChanges();
    }
  }

  async onLandTypeSelect(landType: string): Promise<void> {
    try {
      this.loading = true;
      this.resetData();
      this.cdr.detectChanges();
      // if (!this.soilData || !this.soilData.soil_data) {
      //   return;
      // }
      const bulkResponse = await this.req.getBulkBenchmark(landType).pipe(first()).toPromise();
      if (!Array.isArray(bulkResponse)) {
        return;
      }
      const phResponse = await this.req.getPhBenchmark(landType).pipe(first()).toPromise();
      if (!Array.isArray(phResponse)) {
        return;
      }
      const socResponse = await this.req.getSoilBenchmark(landType).pipe(first()).toPromise();
      if (!Array.isArray(socResponse)) {
        return;
      }
      this.updateChartData(this.bulkData, 'Bulk Density', bulkResponse);
      this.updateChartData(this.phData, 'pH', phResponse);
      this.updateChartData(this.socData, 'Soil Carbon', socResponse);

      this.benchmarkingDataAvailable = true;
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error:', error);
    } finally {
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  updateChartData(chartData: any[], label: string, response: any[]): void {
    const updatedData = response.map((item) => ({
      x: item.observation,
      y: item.ecdf,
    }));
    chartData.length = 0;

    const lower = response[0]?.lower;
    const upper = response[0]?.upper;

    const belowTypical = response.filter((item) => item.observation < lower);
    const typical = response.filter((item) => item.observation >= lower && item.observation <= upper);
    const aboveTypical = response.filter((item) => item.observation > upper);

    chartData.push(
      {
        label: 'Below Typical',
        data: belowTypical.map((item) => ({ x: Number(item.observation), y: item.ecdf * 100 })),
        borderColor: 'green',
        backgroundColor: 'rgba(0, 255, 0, 0.3)',
        borderWidth: 0,
        showLine: true,
        fill: true,
        pointBorderColor: 'green',
        pointBackgroundColor: 'rgba(0, 255, 0, 0.3)'
      },
      {
        label: 'Typical',
        data: typical.map((item) => ({ x: Number(item.observation), y: item.ecdf * 100 })),
        borderColor: 'blue',
        backgroundColor: 'rgba(0, 0, 255, 0.3)',
        borderWidth: 0,
        showLine: true,
        fill: true,
        pointBorderColor: 'blue',
        pointBackgroundColor: 'rgba(0, 0, 255, 0.3)'
      },
      {
        label: 'Above Typical',
        data: aboveTypical.map((item) => ({ x: Number(item.observation), y: item.ecdf * 100 })),
        borderColor: 'purple',
        backgroundColor: 'rgba(128, 0, 128, 0.3)',
        borderWidth: 0,
        showLine: true,
        fill: true,
        pointBorderColor: 'purple',
        pointBackgroundColor: 'rgba(128, 0, 128, 0.3)'
      }
    );

    this.addBounds(chartData, lower, upper, label);

    let property;
    switch (label) {
      case 'Bulk Density':
        property = this.bdod;
        break;
      case 'pH':
        property = this.ph;
        break;
      case 'Soil Carbon':
        property = this.soc;
        break;
      default:
        return;
    }

    this.addProperty(chartData, property, label);
    this.cdr.detectChanges();
  }


  addBounds(chartData: any[], lower: number, upper: number, label: string): void {
    const lowerTooltip = `${10}% of soils have a ${label} less than ${lower}`;
    const upperTooltip = `${10}% of soils have a ${label} greater than ${upper}`;
    chartData.push(
      {
        label: 'Lower end of typical range',
        data: [{ x: lower, y: 0 }, { x: lower, y: 100 }],
        borderColor: 'red',
        backgroundColor: 'rgb(239, 83, 80)',
        borderWidth: 1,
        showLine: true,
        pointRadius: 3,
        fill: false,
        tooltip: {
          callbacks: {
            label: () => lowerTooltip
          }
        }
      },
      {
        label: 'Upper end of typical range',
        data: [{ x: upper, y: 0 }, { x: upper, y: 100 }],
        borderColor: 'red',
        backgroundColor: 'rgb(239, 83, 80)',
        borderWidth: 1,
        showLine: true,
        pointRadius: 3,
        fill: false,
        tooltip: {
          callbacks: {
            label: () => upperTooltip
          }
        }
      }
    );
  }

  addProperty(chartData: any[], value: number, label: string): void {
    const index = chartData.findIndex(item => item.label.startsWith("Selected Location"));
    if (index !== -1) {
      chartData.splice(index, 1);
    }

    this.selectedLocation = value;

    chartData.push({
      label: 'Selected Location',
      data: [{ x: value, y: 0 }, { x: value, y: 100 }],
      borderColor: 'rgb(144, 238, 144)',
      borderWidth: 2,
      showLine: true,
      pointRadius: 1,
      borderDash: [5, 5],
    });

    this.cdr.detectChanges();
  }

  openInfo() {
    this.dialog.open(InfoDialogComponent, { autoFocus: false, disableClose: false, width: '90%', height: '90%' })
  }

  getEconomicalData(): void {
    this.loading = true;
    this.resetData();
    this.cdr.detectChanges();

    const yieldForCalculation = this.yield !== null ? this.yield : 0.0;

    this.req.getEconomicValues(
      this.latitude,
      this.longitude,
      this.farmingSystem,
      this.cropType,
      this.farmArea,
      yieldForCalculation,
      this.bdod,
      this.ph,
      this.soc,
      this.nutsId,
      this.clay,
      this.ocs
    ).subscribe(
      (res: CarbonData) => {
        if (res) {
          const economicValues = res;
          const table = res.table.table

          const isPerHectare = !this.farmArea;
          const unitYield = isPerHectare ? 'tonne/ha' : 'tonnes';
          const unitEV = isPerHectare ? '€/ha' : '€';

          this.firstTableData = [
            { 
              ncp: 'Carbon stock', 
              conventional: economicValues.cstock_c_sg.toFixed(2) + ' tonnes', 
              organic: economicValues.cstock_o_sg.toFixed(2), 
              economic: economicValues.ev.toFixed(2) },
            {
              ncp: 'Yield', 
              conventional: economicValues.yield_conv ? economicValues.yield_conv.toFixed(2) + ' tonnes' : 'N/A',
              organic: economicValues.yield_org ? economicValues.yield_org.toFixed(2) : 'N/A',
              economic: economicValues.yd_ev ? economicValues.yd_ev.toFixed(2) : 'N/A'
            },
            {
              ncp: 'Hydraulic contuctivity', 
              conventional: table.Ksat_conv.value.toFixed(2) + ' ' + table.Ksat_conv.unit,
              organic: table.Ksat_org.value.toFixed(2) + ' ' + table.Ksat_org.unit,
              economic: 'N/A'
            },
            {
              ncp: 'Saturated water content', 
              conventional: table.ThetaS_conv.value.toFixed(2) + ' ' + table.ThetaS_conv.unit,
              organic: table.ThetaS_org.value.toFixed(2) + ' ' + table.ThetaS_org.unit,
              economic: table.EV_eur_per_ha.value.toFixed(2) + ' ' + table.EV_eur_per_ha.unit,
            },
          ];

          this.secondTableData = [
            { measureName: 'Conventional yield', measure: economicValues.yield_conv ? economicValues.yield_conv.toFixed(2) : 'N/A', unit: unitYield },
            { measureName: 'Organic yield', measure: economicValues.yield_org ? economicValues.yield_org.toFixed(2) : 'N/A', unit: unitYield },
            { measureName: 'Economic value', measure: economicValues.ev ? economicValues.ev.toFixed(2) : 'N/A', unit: unitEV },
            { measureName: 'Relative yield conventional', measure: economicValues.ryield_conv ? economicValues.ryield_conv.toFixed(2) : 'N/A', unit: 'N/A' },
            { measureName: 'Relative yield organic', measure: economicValues.ryield_org ? economicValues.ryield_org.toFixed(2) : 'N/A', unit: 'N/A' },
          ];

          this.barChartData = [
            {
              label: `Economic Value (${unitEV})`,
              data: [economicValues.yd_ev, economicValues.ev, table.EV_eur_per_ha.value],
              backgroundColor: [' #FF6347', 'rgb(113,187,212)', 'rgb(230, 255, 8)'],
            },
          ];

          this.economicValuesAvailable = true;
        }
        this.loading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.loading = false;
        console.error('Error fetching economic values:', error);
      }
    );
  }

  resetData(): void {
    this.isSaved = false;
    this.benchmarkingDataAvailable = false;
    this.predictionDataAvailable = false;
    this.economicValuesAvailable = false;
  }
}